<app-top-nav class="force-dark-theme" />
<router-outlet />
<app-footer class="force-dark-theme" />
